import React from 'react';

import Loader from 'react-loader-spinner'

const CenteredLoader = ({ isVisible, text }) => {
    return (
        isVisible && <div className="text-center">
            <Loader
                type="RevolvingDot"
                color="#007BFF"
                height="50"
                width="50"
            />
            {text && <h3>{text}</h3>}
        </div>
    );
}

export default CenteredLoader;



// WEBPACK FOOTER //
// ./src/components/CenteredLoader.js